<template>
  <div>
    <footer class="footer mt-05">
      <div class="content">
        <div class="columns">
          <div class="column is-4">
            <h4 class="has-text-light">Dirección</h4>
            <address>
              Sindicato de la CROC Cancun<br>
              Sm63, Mz12, Lt15, Calle11,<br>
              A un costado del Parián. (CROC Cancún)<br>
              77513 Teléfono: +52-998-310-5049<br>
            </address>
          </div>
          <div class="column is-4">
            <h4 class="has-text-light">Sitios de Interes</h4>
						<ul>
							<li><a href="http://www.croc.org.mx" target="_blank">CROC Nacional</a></li>
							<li><a href="http://www.gob.mx/">Gobierno Digital</a></li>
							<li><a href="http://www.infonavit.org.mx" target="_blank">Infornavit</a></li>
							<li><a href="http://www.imss.gob.mx/" target="_blank">IMSS</a></li>
							<li><a href="http://www.gob.mx/sre" target="_blank">Secretaria de Relaciones Exteriores</a></li>
							<li><a href="http://www.quintanaroo.gob.mx" target="_blank">Gobierno del Estado de Quintana Roo</a></li>
						</ul>
          </div>
          <div class="column is-4">
            <h4 class="has-text-light">Redes Sociales</h4>
            <a href="https://twitter.com/crocqroo" target="_blank" title="twitter"><img :src="twitterimg" alt="Twitter"/></a>
            <a href="https://www.facebook.com/crocquintanaroo" target="_blank" title="facebook"><img :src="facebookimg" alt="Facebook"/></a>
            <a href="https://www.instagram.com/crocqroo/" target="_blank" title="instagram"><img :src="instagramimg" alt="Instagram"/></a>
            <a href="https://www.youtube.com/user/CROCQUINTANAROO" target="_blank" title="youtube"><img :src="youtubeimg" alt="Youtube"/></a>
          </div>
        </div>
        <nav class="level mt-01">
          <p class="level-item has-text-centered">
            <router-link to="/" class="link is-info">Inicio</router-link>
          </p>
          <p class="level-item has-text-centered">
            <a class="link is-info" href="http://www.radiocroc.com">Radio</a>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{name:'Programas'}" class="link is-info">Programas</router-link>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{name:'Videos'}" class="link is-info">Videos</router-link>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{name:'Vacantes'}" class="link is-info">Vacantes</router-link>
          </p>
          <p class="level-item has-text-centered">
            <router-link :to="{name:'Contacto'}" class="link is-info">Contacto</router-link>
          </p>
        </nav>
        <p class="has-text-centered">Derechos reservados. CROC Cancun © 2016</p>
      </div>
    </footer>
  </div>
</template>

<script>
import facebook from '@/assets/img/facebook.png'
import twitter from '@/assets/img/twitter.png'
import instagram from '@/assets/img/instagram.png'
import youtube from '@/assets/img/youtube.png'

export default {
  data () {
    return {
      facebookimg:facebook,
      twitterimg:twitter,
      instagramimg:instagram,
      youtubeimg:youtube,
    }
  },
  methods:{
  },
  created :function(){
  }
}
</script>

<style>
li{
  list-style: none;
}
.mt-05{
  margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Footer.vue